<template>
  <generic-modal
    :is_wide="true"
    :title="$t('product status')"
    ref="generic_modal"
  >
    <div class="title is-3">{{ meta.name }}</div>
    <table class="table is-fullwidth is-hoverable">
      <thead>
        <tr>
          <th>{{ $t("date") }}</th>
          <th>{{ $t("movement type") }}</th>
          <th>{{ $t("quantity") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="movement in meta.inventory_movements">
          <td>{{ format_date_time(movement.create_date) }}</td>
          <td>{{ movement.movement_type.name }}</td>
          <td>{{ movement.quantity }}</td>
        </tr>
      </tbody>
    </table>
    <!-- <pre>{{ meta }}</pre> -->
    <template v-slot:footer>
      <button
        class="button is-rounded"
        @click="$refs.generic_modal.close_modal"
      >
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  get,
  post,
  format_date_time,
  generate_error_message_text,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "ProductStatusModal",
  components: { GenericModal },
  props: {},
  data() {
    return {
      meta: {},
    };
  },
  computed: {},
  methods: {
    format_date_time,
    show_modal(product_uuid) {
      let v = this;
      v.set_initial_state();
      get("/inventory/product_status", { uuid: product_uuid })
        .then((product_status) => {
          v.meta = product_status;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
      v.$refs.generic_modal.show_modal();
    },
    set_initial_state() {
      let v = this;
      v.meta = {};
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
